import { useTranslation } from 'react-i18next'
import { Col, Modal, Row } from 'antd'

import CustomButton from '@/components/CustomButton'

import styles from './ConfirmModal.module.scss'

const ConfirmModal = (props) => {
  const {
    modalTitle = '',
    modalContent = '',
    isShowModal = false,
    setIsShowModal,
    confirmActionHandler,
  } = props
  const { t } = useTranslation()

  const onConfirmHandler = () => {
    setIsShowModal(false)

    confirmActionHandler()
  }

  const onCancelHandler = () => {
    setIsShowModal(false)
  }

  const renderFooterContent = () => {
    return (
      <Row justify="space-between">
        <Col lg={6} md={6} sm={24} xl={6} xs={24}>
          <CustomButton type="ghost" onClick={onCancelHandler}>
            {t('adminWorkspace.userManagement.confirmModal.cancel')}
          </CustomButton>
        </Col>
        <Col
          lg={6}
          md={6}
          sm={24}
          xl={6}
          xs={24}
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <CustomButton onClick={onConfirmHandler}>
            {t('adminWorkspace.userManagement.confirmModal.confirm')}
          </CustomButton>
        </Col>
      </Row>
    )
  }

  return (
    <Modal
      className={styles['confirm-modal']}
      closable={false}
      footer={renderFooterContent()}
      open={isShowModal}
      title={modalTitle}
      width={570}
      onCancel={onCancelHandler}
      onOk={onConfirmHandler}
    >
      <div>{modalContent}</div>
    </Modal>
  )
}

export default ConfirmModal
